import { Api } from "@/api/worker"
import { useToast } from "@/hooks/use-toast"
import { ReportSave } from "@/state/report"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { QUERY_KEYS } from "./queryKeys"

export const useAcceptTerms = (id: string, key: string) => {
	const queryClient = useQueryClient()
	const { toast } = useToast()
	return useMutation({
		mutationFn: () => {
			return Api.acceptTerms({
				body: {
					report_id: id,
					key: key,
				},
			})
		},
		onSuccess: () => {
			queryClient.setQueryData<ReportSave>(QUERY_KEYS.report(id, key), (prev) => {
				if (!prev) return prev
				return { ...prev, terms_accepted: true }
			})
		},
		onError: () => {
			toast({
				variant: "destructive",
				title: "Error",
				description: "Failed to accept terms",
			})
		},
	})
}
